import React, { useState } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { Swords, Target, Users, AlertTriangle, MessageCircle, Bot } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { ChartContainer, ChartTooltipContent } from '../components/Chart';
import { Button } from '../components/Button';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/Dialog';
import { Badge } from '../components/Badge';
const trend = [{
  d: 'Sen',
  sent: 65
}, {
  d: 'Sel',
  sent: 70
}, {
  d: 'Rab',
  sent: 68
}, {
  d: 'Kam',
  sent: 72
}, {
  d: 'Jum',
  sent: 75
}, {
  d: 'Sab',
  sent: 73
}, {
  d: 'Min',
  sent: 72
}];
const config = {
  sent: {
    label: 'Sentimen Positif',
    color: 'hsl(142, 76%, 36%)'
  }
};
const threats = [{
  lbl: 'Hoaks distribusi tidak merata',
  risk: 'TINGGI',
  src: 'WhatsApp Channels'
}, {
  lbl: 'Komentar kritik kualitas makanan',
  risk: 'SEDANG',
  src: 'TikTok'
}, {
  lbl: 'Klaim politisasi program',
  risk: 'TINGGI',
  src: 'X / Opini publik'
}, {
  lbl: 'Spam komentar di rilis resmi',
  risk: 'RENDAH',
  src: 'IG Komentar'
}];
const advocates = [{
  name: 'Sukma N.',
  handle: '@sukmaa.n',
  reach: '890K',
  sentiment: 'POSITIF'
}, {
  name: 'Tani Sejahtera',
  handle: '@tanisejahtera_id',
  reach: '340K',
  sentiment: 'POSITIF'
}, {
  name: 'Anak SMA Ngonten',
  handle: '@dhito.real',
  reach: '210K',
  sentiment: 'POSITIF'
}];
const availablePrograms = [{
  name: 'Makan Bergizi Gratis',
  short: 'MBG',
  sent: 72
}, {
  name: 'Subsidi BBM Tepat Sasaran',
  short: 'BBM',
  sent: 38
}, {
  name: 'Ibu Kota Nusantara',
  short: 'IKN',
  sent: 42
}, {
  name: 'Bansos Pangan',
  short: 'BANSOS',
  sent: 45
}, {
  name: 'Hilirisasi Nikel',
  short: 'NIKEL',
  sent: 58
}];
export function ProgramWarRoom() {
  const [programDialogOpen, setProgramDialogOpen] = useState(false);
  const [currentProgram, setCurrentProgram] = useState('MBG');
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-2937">
      <PageHeader group="Stabilitas Nasional" title={`Presidential Program War Room — ${currentProgram}`} description={`War room dedicated untuk program prioritas Presiden: ${availablePrograms.find(p => p.short === currentProgram)?.name}. Pantau penerimaan publik & ancaman narasi.`} icon={Swords} extraActions={<Button size="sm" variant="outline" onClick={() => setProgramDialogOpen(true)} data-id="element-2939">
            Ganti Program
          </Button>} data-id="element-2938" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2940">
        {[{
        l: 'Sentimen Positif',
        v: '72%',
        i: Target,
        c: 'text-emerald-500'
      }, {
        l: 'Reach 7 Hari',
        v: '14.2M',
        i: Users,
        c: 'text-blue-500'
      }, {
        l: 'Ancaman Narasi',
        v: '4',
        i: AlertTriangle,
        c: 'text-amber-500'
      }, {
        l: 'Advocate Aktif',
        v: '23',
        i: MessageCircle,
        c: 'text-purple-500'
      }].map(k => <Card key={k.l} className="bg-card border-border/50" data-id="element-2941">
            <CardContent className="p-4 flex items-center justify-between" data-id="element-2942">
              <div data-id="element-2943">
                <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-2944">
                  {k.l}
                </p>
                <p className={`font-heading text-2xl font-bold mt-1 ${k.c}`} data-id="element-2945">
                  {k.v}
                </p>
              </div>
              <k.i className={`size-6 ${k.c}`} data-id="element-2946" />
            </CardContent>
          </Card>)}
      </div>

      <div className="grid grid-cols-12 gap-4" data-id="element-2947">
        <Card className="col-span-12 lg:col-span-8 bg-card border-border/50" data-id="element-2948">
          <CardContent className="p-4" data-id="element-2949">
            <h3 className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-3" data-id="element-2950">
              Tren Sentimen Positif (7 Hari)
            </h3>
            <div className="h-[260px]" data-id="element-2951">
              <ChartContainer config={config} className="h-full w-full" data-id="element-2952">
                <LineChart data={trend} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-2953">
                  <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} data-id="element-2954" />
                  <XAxis dataKey="d" stroke="hsl(var(--muted-foreground))" fontSize={10} tickLine={false} axisLine={false} data-id="element-2955" />
                  <YAxis stroke="hsl(var(--muted-foreground))" fontSize={10} tickLine={false} axisLine={false} domain={[60, 80]} data-id="element-2956" />
                  <Tooltip content={<ChartTooltipContent data-id="element-2958" />} data-id="element-2957" />
                  <Line type="monotone" dataKey="sent" stroke="var(--color-sent)" strokeWidth={2} dot={{
                  r: 4
                }} data-id="element-2959" />
                </LineChart>
              </ChartContainer>
            </div>
          </CardContent>
        </Card>

        <Card className="col-span-12 lg:col-span-4 bg-card border-border/50" data-id="element-2960">
          <CardContent className="p-4" data-id="element-2961">
            <h3 className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-3 flex items-center gap-2" data-id="element-2962">
              <AlertTriangle className="size-4 text-amber-500" data-id="element-2963" />
              Ancaman Narasi
            </h3>
            <div className="space-y-2" data-id="element-2964">
              {threats.map(t => <div key={t.lbl} className={`p-2 rounded border ${t.risk === 'TINGGI' ? 'border-red-500/30 bg-red-500/5' : t.risk === 'SEDANG' ? 'border-amber-500/30 bg-amber-500/5' : 'border-blue-500/30 bg-blue-500/5'}`} data-id="element-2965">
                  <p className="text-xs font-medium" data-id="element-2966">{t.lbl}</p>
                  <div className="flex justify-between font-mono text-[9px] mt-1" data-id="element-2967">
                    <span className="text-muted-foreground" data-id="element-2968">{t.src}</span>
                    <span className={`${t.risk === 'TINGGI' ? 'text-red-500' : t.risk === 'SEDANG' ? 'text-amber-500' : 'text-blue-500'}`} data-id="element-2969">
                      {t.risk}
                    </span>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-card border-border/50" data-id="element-2970">
        <CardContent className="p-4" data-id="element-2971">
          <h3 className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-3 flex items-center gap-2" data-id="element-2972">
            <Bot className="size-4 text-primary" data-id="element-2973" />
            Advocate Network (Organik)
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-2974">
            {advocates.map(a => <div key={a.handle} className="p-3 rounded border border-emerald-500/30 bg-emerald-500/5" data-id="element-2975">
                <p className="text-sm font-bold" data-id="element-2976">{a.name}</p>
                <p className="font-mono text-[10px] text-muted-foreground" data-id="element-2977">
                  {a.handle}
                </p>
                <div className="flex justify-between items-center mt-2" data-id="element-2978">
                  <span className="font-mono text-[9px] text-emerald-500" data-id="element-2979">
                    {a.sentiment}
                  </span>
                  <span className="font-mono text-[10px]" data-id="element-2980">{a.reach} reach</span>
                </div>
              </div>)}
          </div>
        </CardContent>
      </Card>

      <Dialog open={programDialogOpen} onOpenChange={setProgramDialogOpen} data-id="element-2981">
        <DialogContent className="sm:max-w-[425px] border-border/50 bg-background/95 backdrop-blur" data-id="element-2982">
          <DialogHeader data-id="element-2983">
            <DialogTitle className="font-mono text-sm uppercase tracking-wider text-foreground flex items-center gap-2" data-id="element-2984">
              <Swords className="size-4 text-primary" data-id="element-2985" />
              Pilih Program War Room
            </DialogTitle>
            <DialogDescription className="text-xs" data-id="element-2986">
              Pilih program prioritas Presiden untuk memantau stabilitas dan
              ancaman narasi.
            </DialogDescription>
          </DialogHeader>

          <div className="grid gap-3 py-4" data-id="element-2987">
            {availablePrograms.map(p => <div key={p.short} className="flex items-center justify-between p-3 rounded-lg border border-border/50 bg-card hover:border-primary/40 hover:bg-primary/5 transition" data-id="element-2988">
                <div data-id="element-2989">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2990">
                    <h4 className="text-sm font-bold" data-id="element-2991">{p.name}</h4>
                    <Badge variant="outline" className="font-mono text-[9px] h-4 px-1.5" data-id="element-2992">
                      {p.short}
                    </Badge>
                  </div>
                  <p className="font-mono text-[10px] text-muted-foreground flex items-center gap-1" data-id="element-2993">
                    Sentimen Positif:
                    <span className={p.sent >= 60 ? 'text-emerald-500' : p.sent >= 40 ? 'text-amber-500' : 'text-red-500'} data-id="element-2994">
                      {p.sent}%
                    </span>
                  </p>
                </div>
                <Button size="sm" variant={currentProgram === p.short ? 'default' : 'outline'} onClick={() => {
              setCurrentProgram(p.short);
              setProgramDialogOpen(false);
              toast.success(`War Room dialihkan ke ${p.short}`);
            }} data-id="element-2995">
                  {currentProgram === p.short ? 'Aktif' : 'Pilih'}
                </Button>
              </div>)}
          </div>
        </DialogContent>
      </Dialog>
    </div>;
}